import React from 'react';
import { Button } from '@mui/material';
import { SITE } from '../data/site';

export default function CalButton({
  type = 'demo',
  children,
  variant = 'contained',
  size = 'large',
  color,
  sx,
  fullWidth,
}) {
  if (type === 'contact') {
    return (
      <Button
        component="a"
        href={`mailto:${SITE.email}`}
        variant={variant}
        size={size}
        color={color}
        fullWidth={fullWidth}
        sx={sx}
      >
        {children}
      </Button>
    );
  }
  return (
    <Button
      component="a"
      href={SITE.calendly}
      target="_blank"
      rel="noopener noreferrer"
      variant={variant}
      size={size}
      color={color}
      fullWidth={fullWidth}
      sx={sx}
    >
      {children}
    </Button>
  );
}
